// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"46":"BadgeTooltipV1","276":"GuestLazyComponent"}[chunkId] + "." + {"46":"ce3777a29fbe2e53cd81","276":"5cde719445370b32796d"}[chunkId] + ".js";
};